import { useQuery } from "react-query";
import TrainingPlansApiClient from "api/TrainingPlansApiClient.js";

export function useMunicipalityTrainingPlans(municipalityId, payload, options) {
    return useQuery(
        ["trainingPlans", "municipality", Number(municipalityId), payload],
        () => TrainingPlansApiClient.getMunicipalityTrainingPlans(municipalityId, payload),
        options,
    );
}
